import { Button } from '@/shared/ui/button';

type ClaudeCodeActionsProps = {
  isOff: boolean;
  isRejected: boolean;
  onOpenForm: () => void;
  onAskDisconnect: () => void;
};

export function ClaudeCodeActions({
  isOff,
  isRejected,
  onOpenForm,
  onAskDisconnect,
}: ClaudeCodeActionsProps) {
  if (isOff) {
    return (
      <div className="flex flex-wrap gap-2">
        <Button variant="primary" onClick={onOpenForm}>
          Connect Claude Code
        </Button>
      </div>
    );
  }
  return (
    <div className="flex flex-wrap gap-2">
      <Button variant={isRejected ? 'primary' : 'default'} onClick={onOpenForm}>
        Replace key
      </Button>
      <Button variant="ghost" className="text-danger-text" onClick={onAskDisconnect}>
        Disconnect
      </Button>
    </div>
  );
}
